export const selectVerifiedEmailAddresses = state => state.verifiedEmailAddresses ? state.verifiedEmailAddresses.data : null

export const selectFetchingVerifiedEmailAddresses = state => state.verifiedEmailAddresses ? state.verifiedEmailAddresses.fetching : false

export const selectVerifyingEmailAddress = state => state.verifiedEmailAddresses ? state.verifiedEmailAddresses.verifying : false
